/**
 * Created by jv on 24/01/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");
const Order = require("Sources/models/order");
const Ticket = require("Sources/models/ticket");
const Error = require("Sources/models/error");

var orderServices = {};

(function(OrderServices)
{
  function dataToError(data, callback)
  {
    if(utils.isFunction(callback))
    {
      if(data.hasOwnProperty("exception"))
      {
        callback(new Error(data.exception));
      }
      else
      {
        callback(new Error({
          code: null,
          message: null
        }));
      }
    }
  }

  OrderServices.getOrdersForProfile = function(profileKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("list_orders_for_profile"),
      cache: false,
      dataType: "json",
      data: {
        "profile-key": profileKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var orders = [];

        if (data.result.result.hasOwnProperty("orders"))
        {
          for (var i = 0; i < data.result.result.orders.length; i++)
          {
            orders.push(new Order(data.result.result.orders[i]));
          }
        }

        successCb(orders);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  OrderServices.getOrderDetails = function(orderNumber, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_order_details"),
      cache: false,
      dataType: "json",
      data: {
        number: orderNumber
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Order(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  OrderServices.cancelOrder = function(orderNumber, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("cancel_order"),
      cache: false,
      dataType: "json",
      data: {
        number: orderNumber
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Order(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  OrderServices.listOrderTickets = function(orderNumber, ticketType, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("get_order_tickets"),
        cache: false,
        dataType: "json",
        data: {
          "order-number": orderNumber,
          "ticket-type": ticketType
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var tickets = [];

          if(data.result.result.hasOwnProperty("ticket-list"))
          {
            for(var i = 0; i < data.result.result["ticket-list"].length; i++)
            {
              tickets.push(new Ticket(data.result.result["ticket-list"][i]));
            }
          }

          successCb(tickets);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

}(orderServices));

module.exports = orderServices;



// WEBPACK FOOTER //
// ./app/js/services/fundels/order-services.js